import React from 'react';
import { string } from 'prop-types';

const getPath = (name) => {
  switch (name) {
    case 'one-column-full-width':
      return (
        <g fillRule="evenodd">
          <path
            d="M35,0 L2,0 C0.896,0 0,0.896 0,2 L0,23 C0,24.104 0.896,25 2,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 L35,0 Z M2,23 L35,23 L35,2 L2,2 L2,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'one-column-large':
      return (
        <g fillRule="evenodd">
          <g id="Group-2">
            <polygon
              fill="#7D7D7D"
              points="34.0002 4.97379915e-14 34.0002 1.001 36.0002 1.001 36.0002 2.284 37.0002 2.284 37.0002 4.97379915e-14"
            />
            <polygon
              fill="#7D7D7D"
              points="29.0002 1.001 32.0012 1.001 32.0012 9.9475983e-14 29.0002 9.9475983e-14"
            />
            <polygon
              fill="#7D7D7D"
              points="36.0002 7.285 37.0002 7.285 37.0002 4.285 36.0002 4.285"
            />
            <polygon
              fill="#7D7D7D"
              points="36.0002 12.285 37.0002 12.285 37.0002 9.284 36.0002 9.284"
            />
            <polygon
              fill="#7D7D7D"
              points="36.0002 17.285 37.0002 17.285 37.0002 14.285 36.0002 14.285"
            />
            <polygon
              fill="#7D7D7D"
              points="36.0002 22.285 37.0002 22.285 37.0002 19.284 36.0002 19.284"
            />
            <polygon
              fill="#7D7D7D"
              points="34.7152 25 36.9992 25 36.9992 24 34.7152 24"
            />
            <polygon
              fill="#7D7D7D"
              points="29.7162 25 32.7162 25 32.7162 24 29.7162 24"
            />
            <path
              d="M28,0.0004 L2,0.0004 C0.896,0.0004 0,0.8964 0,2.0004 L0,23.0004 C0,24.1044 0.896,25.0004 2,25.0004 L28,25.0004 L28,0.0004 Z M2,23.0004 L26,23.0004 L26,2.0004 L2,2.0004 L2,23.0004 Z"
              fill="#FFFFFF"
            />
          </g>
        </g>
      );
    case 'one-column-medium':
      return (
        <g fillRule="evenodd">
          <polygon
            fill="#7D7D7D"
            points="34.0002 0.0003 34.0002 1.0003 36.0002 1.0003 36.0002 2.2843 37.0002 2.2843 37.0002 0.0003"
          />
          <polygon
            fill="#7D7D7D"
            points="29.0002 1.0003 32.0012 1.0003 32.0012 0.0003 29.0002 0.0003"
          />
          <polygon
            fill="#7D7D7D"
            points="24.0002 1.0003 27.0002 1.0003 27.0002 0.0003 24.0002 0.0003"
          />
          <polygon
            fill="#7D7D7D"
            points="36.0002 7.2843 37.0002 7.2843 37.0002 4.2843 36.0002 4.2843"
          />
          <polygon
            fill="#7D7D7D"
            points="36.0002 12.2843 37.0002 12.2843 37.0002 9.2833 36.0002 9.2833"
          />
          <polygon
            fill="#7D7D7D"
            points="36.0002 17.2843 37.0002 17.2843 37.0002 14.2843 36.0002 14.2843"
          />
          <polygon
            fill="#7D7D7D"
            points="36.0002 22.2843 37.0002 22.2843 37.0002 19.2843 36.0002 19.2843"
          />
          <polygon
            fill="#7D7D7D"
            points="34.7152 24.9993 36.9992 24.9993 36.9992 23.9993 34.7152 23.9993"
          />
          <polygon
            fill="#7D7D7D"
            points="29.7162 24.9993 32.7162 24.9993 32.7162 23.9993 29.7162 23.9993"
          />
          <polygon
            fill="#7D7D7D"
            points="24.7162 24.9993 27.7162 24.9993 27.7162 23.9993 24.7162 23.9993"
          />
          <path
            d="M25,0 L2,0 C0.896,0 0,0.896 0,2 L0,23 C0,24.104 0.896,25 2,25 L25,25 L25,0 Z M2,23 L23,23 L23,2 L2,2 L2,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'one-column-small':
      return (
        <g fillRule="evenodd">
          <polygon
            fill="#7D7D7D"
            points="34.0002 0.0001 34.0002 1.0001 36.0002 1.0001 36.0002 2.2841 37.0002 2.2841 37.0002 0.0001"
          />
          <polygon
            fill="#7D7D7D"
            points="29.0002 1.0001 32.0012 1.0001 32.0012 0.0001 29.0002 0.0001"
          />
          <polygon
            fill="#7D7D7D"
            points="24.0002 1.0001 27.0002 1.0001 27.0002 0.0001 24.0002 0.0001"
          />
          <polygon
            fill="#7D7D7D"
            points="19.0002 1.0001 22.0002 1.0001 22.0002 0.0001 19.0002 0.0001"
          />
          <polygon
            fill="#7D7D7D"
            points="36.0002 7.2841 37.0002 7.2841 37.0002 4.2841 36.0002 4.2841"
          />
          <polygon
            fill="#7D7D7D"
            points="36.0002 12.2841 37.0002 12.2841 37.0002 9.2841 36.0002 9.2841"
          />
          <polygon
            fill="#7D7D7D"
            points="36.0002 17.2851 37.0002 17.2851 37.0002 14.2841 36.0002 14.2841"
          />
          <polygon
            fill="#7D7D7D"
            points="36.0002 22.2841 37.0002 22.2841 37.0002 19.2841 36.0002 19.2841"
          />
          <polygon
            fill="#7D7D7D"
            points="34.7152 25.0001 36.9992 25.0001 36.9992 24.0001 34.7152 24.0001"
          />
          <polygon
            fill="#7D7D7D"
            points="29.7162 25.0001 32.7162 25.0001 32.7162 24.0001 29.7162 24.0001"
          />
          <polygon
            fill="#7D7D7D"
            points="24.7162 25.0001 27.7162 25.0001 27.7162 24.0001 24.7162 24.0001"
          />
          <polygon
            fill="#7D7D7D"
            points="19.7152 25.0001 22.7162 25.0001 22.7162 24.0001 19.7152 24.0001"
          />
          <path
            d="M19,0 L2,0 C0.896,0 0,0.896 0,2 L0,23 C0,24.104 0.896,25 2,25 L19,25 L19,0 Z M2,23 L17,23 L17,2 L2,2 L2,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'two-column-text-only':
      return (
        <g fillRule="evenodd">
          <polygon fill="#7D7D7D" points="18 6 19 6 19 3 18 3" />
          <polygon fill="#7D7D7D" points="18 11 19 11 19 8 18 8" />
          <polygon fill="#7D7D7D" points="18 16 19 16 19 13 18 13" />
          <polygon fill="#7D7D7D" points="18 21 19 21 19 17.999 18 17.999" />
          <polygon fill="#7D7D7D" points="18 23 18 24 18 25 19 25 19 23" />
          <path
            d="M35,0 L2,0 C0.896,0 0,0.896 0,2 L0,23 C0,24.104 0.896,25 2,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 L35,0 Z M2,23 L35,23 L35,2 L2,2 L2,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'two-column-narrow-left-left':
      return (
        <g fillRule="evenodd">
          <path
            d="M35,0 L12,0 L12,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,23 C36,23.552 35.552,24 35,24 L13,24 L13,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M13,0 L2,0 C0.896,0 0,0.896 0,2 L0,23 C0,24.104 0.896,25 2,25 L13,25 L13,0 Z M2,23 L11,23 L11,2 L2,2 L2,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'two-column-narrow-left-right':
      return (
        <g fillRule="evenodd">
          <path
            d="M13,0 L2,0 C0.896,0 0,0.896 0,2 L0,23 C0,24.104 0.896,25 2,25 L13,25 L13,0 Z M12,1 L12,24 L2,24 C1.448,24 1,23.552 1,23 L1,2 C1,1.448 1.448,1 2,1 L12,1 L12,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L12,0 L12,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 L35,0 Z M14,23 L35,23 L35,2 L14,2 L14,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'two-column-narrow-right':
      return (
        <g fillRule="evenodd">
          <path
            d="M25,0 L2,0 C0.896,0 0,0.896 0,2 L0,23 C0,24.104 0.896,25 2,25 L25,25 L25,0 Z M24,1 L24,24 L2,24 C1.448,24 1,23.552 1,23 L1,2 C1,1.448 1.448,1 2,1 L24,1 L24,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L24,0 L24,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 L35,0 Z M26,23 L35,23 L35,2 L26,2 L26,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'two-column-narrow-right-left':
      return (
        <g fillRule="evenodd">
          <path
            d="M35,0 L24,0 L24,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,23 C36,23.552 35.552,24 35,24 L25,24 L25,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M25,0 L2,0 C0.896,0 0,0.896 0,2 L0,23 C0,24.104 0.896,25 2,25 L25,25 L25,0 Z M2,23 L23,23 L23,2 L2,2 L2,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'two-column-narrow-right-right':
      return (
        <g fillRule="evenodd">
          <path
            d="M25,0 L2,0 C0.896,0 0,0.896 0,2 L0,23 C0,24.104 0.896,25 2,25 L25,25 L25,0 Z M24,1 L24,24 L2,24 C1.448,24 1,23.552 1,23 L1,2 C1,1.448 1.448,1 2,1 L24,1 L24,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L24,0 L24,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 L35,0 Z M26,23 L35,23 L35,2 L26,2 L26,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'two-column-left':
      return (
        <g fillRule="evenodd">
          <path
            d="M35,0 L18,0 L18,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,23 C36,23.552 35.552,24 35,24 L19,24 L19,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M19,0 L2,0 C0.896,0 0,0.896 0,2 L0,23 C0,24.104 0.896,25 2,25 L19,25 L19,0 Z M2,23 L17,23 L17,2 L2,2 L2,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'two-column-right':
      return (
        <g fillRule="evenodd">
          <path
            d="M19,0 L2,0 C0.896,0 0,0.896 0,2 L0,23 C0,24.104 0.896,25 2,25 L19,25 L19,0 Z M18,1 L18,24 L2,24 C1.448,24 1,23.552 1,23 L1,2 C1,1.448 1.448,1 2,1 L18,1 L18,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L18,0 L18,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 L35,0 Z M20,23 L35,23 L35,2 L20,2 L20,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'stacked-medium-top-top':
      return (
        <g fillRule="evenodd">
          <path
            d="M37,19 L0,19 L0,23 C0,24.104 0.896,25 2,25 L35,25 C36.104,25 37,24.104 37,23 L37,19 Z M36,20 L36,23 C36,23.552 35.552,24 35,24 L2,24 C1.448,24 1,23.552 1,23 L1,20 L36,20 L36,20 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L2,0 C0.896,0 0,0.896 0,2 L0,20 L37,20 L37,2 C37,0.896 36.104,0 35,0 L35,0 Z M2,18 L35,18 L35,2 L2,2 L2,18 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'stacked-medium-top-bottom':
      return (
        <g fillRule="evenodd">
          <path
            d="M35,0 L2,0 C0.896,0 0,0.896 0,2 L0,16 L37,16 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,15 L1,15 L1,2 C1,1.448 1.448,1 2,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M37,15 L0,15 L0,23 C0,24.104 0.896,25 2,25 L35,25 C36.104,25 37,24.104 37,23 L37,15 Z M2,23 L35,23 L35,17 L2,17 L2,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'stacked-large-top-top':
      return (
        <g fillRule="evenodd">
          <path
            d="M37,15 L0,15 L0,23 C0,24.104 0.896,25 2,25 L35,25 C36.104,25 37,24.104 37,23 L37,15 Z M36,16 L36,23 C36,23.552 35.552,24 35,24 L2,24 C1.448,24 1,23.552 1,23 L1,16 L36,16 L36,16 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L2,0 C0.896,0 0,0.896 0,2 L0,16 L37,16 L37,2 C37,0.896 36.104,0 35,0 L35,0 Z M2,14 L35,14 L35,2 L2,2 L2,14 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'stacked-large-top-bottom':
      return (
        <g fillRule="evenodd">
          <path
            d="M35,0 L2,0 C0.896,0 0,0.896 0,2 L0,20 L37,20 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,19 L1,19 L1,2 C1,1.448 1.448,1 2,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M37,19 L0,19 L0,23 C0,24.104 0.896,25 2,25 L35,25 C36.104,25 37,24.104 37,23 L37,19 Z M2,23 L35,23 L35,21 L2,21 L2,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'stacked-large-bottom-top':
      return (
        <g fillRule="evenodd">
          <path
            d="M37,5 L0,5 L0,23 C0,24.104 0.896,25 2,25 L35,25 C36.104,25 37,24.104 37,23 L37,5 Z M36,6 L36,23 C36,23.552 35.552,24 35,24 L2,24 C1.448,24 1,23.552 1,23 L1,6 L36,6 L36,6 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L2,0 C0.896,0 0,0.896 0,2 L0,6 L37,6 L37,2 C37,0.896 36.104,0 35,0 L35,0 Z M2,4 L35,4 L35,2 L2,2 L2,4 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'stacked-large-bottom-bottom':
      return (
        <g fillRule="evenodd">
          <path
            d="M35,0 L2,0 C0.896,0 0,0.896 0,2 L0,6 L37,6 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,5 L1,5 L1,2 C1,1.448 1.448,1 2,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M37,5 L0,5 L0,23 C0,24.104 0.896,25 2,25 L35,25 C36.104,25 37,24.104 37,23 L37,5 Z M2,23 L35,23 L35,7 L2,7 L2,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'two-column-extra-narrow-left':
      return (
        <g fillRule="evenodd">
          <path
            d="M35,0 L27,0 L27,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,23 C36,23.552 35.552,24 35,24 L28,24 L28,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M28,0 L2,0 C0.896,0 0,0.896 0,2 L0,23 C0,24.104 0.896,25 2,25 L28,25 L28,0 Z M2,23 L26,23 L26,2 L2,2 L2,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'two-column-extra-narrow-right-left':
      return (
        <g fillRule="evenodd">
          <path
            d="M35,0 L27,0 L27,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,23 C36,23.552 35.552,24 35,24 L28,24 L28,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M28,0 L2,0 C0.896,0 0,0.896 0,2 L0,23 C0,24.104 0.896,25 2,25 L28,25 L28,0 Z M2,23 L26,23 L26,2 L2,2 L2,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'two-column-extra-narrow-right-right':
      return (
        <g fillRule="evenodd">
          <path
            d="M28,0 L2,0 C0.896,0 0,0.896 0,2 L0,23 C0,24.104 0.896,25 2,25 L28,25 L28,0 Z M27,1 L27,24 L2,24 C1.448,24 1,23.552 1,23 L1,2 C1,1.448 1.448,1 2,1 L27,1 L27,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L27,0 L27,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 L35,0 Z M29,23 L35,23 L35,2 L29,2 L29,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'three-column-left':
      return (
        <g fillRule="evenodd">
          <path
            d="M35,0 L24,0 L24,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,23 C36,23.552 35.552,24 35,24 L25,24 L25,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M12,25 L25,25 L25,0 L12,0 L12,25 Z M13,24 L24,24 L24,1 L13,1 L13,24 Z"
            fill="#7D7D7D"
          />
          <path
            d="M13,0 L2,0 C0.896,0 0,0.896 0,2 L0,23 C0,24.104 0.896,25 2,25 L13,25 L13,0 Z M2,23 L11,23 L11,2 L2,2 L2,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'three-column-middle':
      return (
        <g fillRule="evenodd">
          <path
            d="M13,0 L2,0 C0.896,0 0,0.896 0,2 L0,23 C0,24.104 0.896,25 2,25 L13,25 L13,0 Z M12,1 L12,24 L2,24 C1.448,24 1,23.552 1,23 L1,2 C1,1.448 1.448,1 2,1 L12,1 L12,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L24,0 L24,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,23 C36,23.552 35.552,24 35,24 L25,24 L25,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M12,25 L25,25 L25,0 L12,0 L12,25 Z M14,23 L23,23 L23,2 L14,2 L14,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'three-column-right':
      return (
        <g fillRule="evenodd">
          <path
            d="M13,0 L2,0 C0.896,0 0,0.896 0,2 L0,23 C0,24.104 0.896,25 2,25 L13,25 L13,0 Z M12,1 L12,24 L2,24 C1.448,24 1,23.552 1,23 L1,2 C1,1.448 1.448,1 2,1 L12,1 L12,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M12,25 L25,25 L25,0 L12,0 L12,25 Z M13,24 L24,24 L24,1 L13,1 L13,24 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L24,0 L24,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 L35,0 Z M26,23 L35,23 L35,2 L26,2 L26,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'stacked-with-right-column-top-left':
      return (
        <g fillRule="evenodd">
          <path
            d="M35,0 L18,0 L18,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,23 C36,23.552 35.552,24 35,24 L19,24 L19,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M19,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L19,25 L19,12 Z M18,13 L18,24 L2,24 C1.448,24 1,23.552 1,23 L1,13 L18,13 L18,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M19,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L19,13 L19,0 Z M2,11 L17,11 L17,2 L2,2 L2,11 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'stacked-with-right-column-right':
      return (
        <g fillRule="evenodd">
          <path
            d="M19,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L19,13 L19,0 Z M18,1 L18,12 L1,12 L1,2 C1,1.448 1.448,1 2,1 L18,1 L18,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M19,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L19,25 L19,12 Z M18,13 L18,24 L2,24 C1.448,24 1,23.552 1,23 L1,13 L18,13 L18,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L18,0 L18,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 L35,0 Z M20,23 L35,23 L35,2 L20,2 L20,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'stacked-with-right-column-bottom-left':
      return (
        <g fillRule="evenodd">
          <path
            d="M35,0 L18,0 L18,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,23 C36,23.552 35.552,24 35,24 L19,24 L19,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M19,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L19,13 L19,0 Z M18,1 L18,12 L1,12 L1,2 C1,1.448 1.448,1 2,1 L18,1 L18,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M19,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L19,25 L19,12 Z M2,23 L17,23 L17,14 L2,14 L2,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'stacked-with-narrow-right-column-top-left':
      return (
        <g fillRule="evenodd">
          <path
            d="M25,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L25,25 L25,12 Z M24,13 L24,24 L2,24 C1.448,24 1,23.552 1,23 L1,13 L24,13 L24,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L24,0 L24,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,23 C36,23.552 35.552,24 35,24 L25,24 L25,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M25,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L25,13 L25,0 Z M2,11 L23,11 L23,2 L2,2 L2,11 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'stacked-with-narrow-right-column-right':
      return (
        <g fillRule="evenodd">
          <path
            d="M25,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L25,13 L25,0 Z M24,1 L24,12 L1,12 L1,2 C1,1.448 1.448,1 2,1 L24,1 L24,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M25,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L25,25 L25,12 Z M24,13 L24,24 L2,24 C1.448,24 1,23.552 1,23 L1,13 L24,13 L24,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L24,0 L24,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 L35,0 Z M26,23 L35,23 L35,2 L26,2 L26,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'stacked-with-narrow-right-column-bottom-left':
      return (
        <g fillRule="evenodd">
          <path
            d="M25,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L25,13 L25,0 Z M24,1 L24,12 L1,12 L1,2 C1,1.448 1.448,1 2,1 L24,1 L24,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L24,0 L24,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,23 C36,23.552 35.552,24 35,24 L25,24 L25,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M25,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L25,25 L25,12 Z M2,23 L23,23 L23,14 L2,14 L2,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'stacked-two-block-top-top-left':
      return (
        <g fillRule="evenodd">
          <path
            d="M35,0 L18,0 L18,13 L37,13 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,12 L19,12 L19,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M37,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L35,25 C36.104,25 37,24.104 37,23 L37,12 Z M36,13 L36,23 C36,23.552 35.552,24 35,24 L2,24 C1.448,24 1,23.552 1,23 L1,13 L36,13 L36,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M19,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L19,13 L19,0 Z M2,11 L17,11 L17,2 L2,2 L2,11 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'stacked-two-block-top-top-right':
      return (
        <g fillRule="evenodd">
          <path
            d="M19,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L19,13 L19,0 Z M18,1 L18,12 L1,12 L1,2 C1,1.448 1.448,1 2,1 L18,1 L18,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M37,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L35,25 C36.104,25 37,24.104 37,23 L37,12 Z M36,13 L36,23 C36,23.552 35.552,24 35,24 L2,24 C1.448,24 1,23.552 1,23 L1,13 L36,13 L36,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L18,0 L18,13 L37,13 L37,2 C37,0.896 36.104,0 35,0 L35,0 Z M20,11 L35,11 L35,2 L20,2 L20,11 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'stacked-two-block-top-bottom':
      return (
        <g fillRule="evenodd">
          <path
            d="M35,0 L18,0 L18,13 L37,13 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,12 L19,12 L19,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M19,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L19,13 L19,0 Z M18,1 L18,12 L1,12 L1,2 C1,1.448 1.448,1 2,1 L18,1 L18,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M37,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L35,25 C36.104,25 37,24.104 37,23 L37,12 Z M2,23 L35,23 L35,14 L2,14 L2,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'stacked-two-block-bottom-top':
      return (
        <g fillRule="evenodd">
          <path
            d="M37,12 L18,12 L18,25 L35,25 C36.104,25 37,24.104 37,23 L37,12 Z M36,13 L36,23 C36,23.552 35.552,24 35,24 L19,24 L19,13 L36,13 L36,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M19,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L19,25 L19,12 Z M18,13 L18,24 L2,24 C1.448,24 1,23.552 1,23 L1,13 L18,13 L18,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L37,13 L37,2 C37,0.896 36.104,0 35,0 L35,0 Z M2,11 L35,11 L35,2 L2,2 L2,11 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'stacked-two-block-bottom-bottom-left':
      return (
        <g fillRule="evenodd">
          <path
            d="M37,12 L18,12 L18,25 L35,25 C36.104,25 37,24.104 37,23 L37,12 Z M36,13 L36,23 C36,23.552 35.552,24 35,24 L19,24 L19,13 L36,13 L36,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L37,13 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,12 L1,12 L1,2 C1,1.448 1.448,1 2,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M19,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L19,25 L19,12 Z M2,23 L17,23 L17,14 L2,14 L2,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'stacked-two-block-bottom-bottom-right':
      return (
        <g fillRule="evenodd">
          <path
            d="M19,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L19,25 L19,12 Z M18,13 L18,24 L2,24 C1.448,24 1,23.552 1,23 L1,13 L18,13 L18,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L37,13 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,12 L1,12 L1,2 C1,1.448 1.448,1 2,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M37,12 L18,12 L18,25 L35,25 C36.104,25 37,24.104 37,23 L37,12 Z M20,23 L35,23 L35,14 L20,14 L20,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'four-block-top-left':
      return (
        <g fillRule="evenodd">
          <path
            d="M35,0 L18,0 L18,13 L37,13 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,12 L19,12 L19,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M37,12 L18,12 L18,25 L35,25 C36.104,25 37,24.104 37,23 L37,12 Z M36,13 L36,23 C36,23.552 35.552,24 35,24 L19,24 L19,13 L36,13 L36,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M19,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L19,25 L19,12 Z M18,13 L18,24 L2,24 C1.448,24 1,23.552 1,23 L1,13 L18,13 L18,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M19,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L19,13 L19,0 Z M2,11 L17,11 L17,2 L2,2 L2,11 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'four-block-top-right':
      return (
        <g fillRule="evenodd">
          <path
            d="M37,12 L18,12 L18,25 L35,25 C36.104,25 37,24.104 37,23 L37,12 Z M36,13 L36,23 C36,23.552 35.552,24 35,24 L19,24 L19,13 L36,13 L36,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M19,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L19,13 L19,0 Z M18,1 L18,12 L1,12 L1,2 C1,1.448 1.448,1 2,1 L18,1 L18,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M19,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L19,25 L19,12 Z M18,13 L18,24 L2,24 C1.448,24 1,23.552 1,23 L1,13 L18,13 L18,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L18,0 L18,13 L37,13 L37,2 C37,0.896 36.104,0 35,0 L35,0 Z M20,11 L35,11 L35,2 L20,2 L20,11 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'four-block-bottom-left':
      return (
        <g fillRule="evenodd">
          <path
            d="M35,0 L18,0 L18,13 L37,13 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,12 L19,12 L19,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M37,12 L18,12 L18,25 L35,25 C36.104,25 37,24.104 37,23 L37,12 Z M36,13 L36,23 C36,23.552 35.552,24 35,24 L19,24 L19,13 L36,13 L36,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M19,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L19,13 L19,0 Z M18,1 L18,12 L1,12 L1,2 C1,1.448 1.448,1 2,1 L18,1 L18,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M19,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L19,25 L19,12 Z M2,23 L17,23 L17,14 L2,14 L2,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'four-block-bottom-right':
      return (
        <g fillRule="evenodd">
          <path
            d="M35,0 L18,0 L18,13 L37,13 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,12 L19,12 L19,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M19,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L19,13 L19,0 Z M18,1 L18,12 L1,12 L1,2 C1,1.448 1.448,1 2,1 L18,1 L18,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M19,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L19,25 L19,12 Z M18,13 L18,24 L2,24 C1.448,24 1,23.552 1,23 L1,13 L18,13 L18,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M37,12 L18,12 L18,25 L35,25 C36.104,25 37,24.104 37,23 L37,12 Z M20,23 L35,23 L35,14 L20,14 L20,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'four-block-narrow-right-top-left':
      return (
        <g fillRule="evenodd">
          <path
            d="M25,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L25,25 L25,12 Z M24,13 L24,24 L2,24 C1.448,24 1,23.552 1,23 L1,13 L24,13 L24,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L24,0 L24,13 L37,13 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,12 L25,12 L25,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M37,12 L24,12 L24,25 L35,25 C36.104,25 37,24.104 37,23 L37,12 Z M36,13 L36,23 C36,23.552 35.552,24 35,24 L25,24 L25,13 L36,13 L36,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M25,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L25,13 L25,0 Z M2,11 L23,11 L23,2 L2,2 L2,11 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'four-block-narrow-right-top-right':
      return (
        <g fillRule="evenodd">
          <path
            d="M25,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L25,13 L25,0 Z M24,1 L24,12 L1,12 L1,2 C1,1.448 1.448,1 2,1 L24,1 L24,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M25,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L25,25 L25,12 Z M24,13 L24,24 L2,24 C1.448,24 1,23.552 1,23 L1,13 L24,13 L24,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M37,12 L24,12 L24,25 L35,25 C36.104,25 37,24.104 37,23 L37,12 Z M36,13 L36,23 C36,23.552 35.552,24 35,24 L25,24 L25,13 L36,13 L36,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L24,0 L24,13 L37,13 L37,2 C37,0.896 36.104,0 35,0 L35,0 Z M26,11 L35,11 L35,2 L26,2 L26,11 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'four-block-narrow-right-bottom-left':
      return (
        <g fillRule="evenodd">
          <path
            d="M25,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L25,13 L25,0 Z M24,1 L24,12 L1,12 L1,2 C1,1.448 1.448,1 2,1 L24,1 L24,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L24,0 L24,13 L37,13 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,12 L25,12 L25,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M37,12 L24,12 L24,25 L35,25 C36.104,25 37,24.104 37,23 L37,12 Z M36,13 L36,23 C36,23.552 35.552,24 35,24 L25,24 L25,13 L36,13 L36,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M25,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L25,25 L25,12 Z M2,23 L23,23 L23,14 L2,14 L2,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'four-block-narrow-right-bottom-right':
      return (
        <g fillRule="evenodd">
          <path
            d="M25,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L25,13 L25,0 Z M24,1 L24,12 L1,12 L1,2 C1,1.448 1.448,1 2,1 L24,1 L24,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M25,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L25,25 L25,12 Z M24,13 L24,24 L2,24 C1.448,24 1,23.552 1,23 L1,13 L24,13 L24,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L24,0 L24,13 L37,13 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,12 L25,12 L25,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M37,12 L24,12 L24,25 L35,25 C36.104,25 37,24.104 37,23 L37,12 Z M26,23 L35,23 L35,14 L26,14 L26,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'three-stacked-with-right-column-left-top':
      return (
        <g fillRule="evenodd">
          <path
            d="M35,0 L18,0 L18,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,23 C36,23.552 35.552,24 35,24 L19,24 L19,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M19,16 L0,16 L0,23 C0,24.104 0.896,25 2,25 L19,25 L19,16 Z M18,17 L18,24 L2,24 C1.448,24 1,23.552 1,23 L1,17 L18,17 L18,17 Z"
            fill="#7D7D7D"
          />
          <path
            d="M0,17 L19,17 L19,8 L0,8 L0,17 Z M1,16 L18,16 L18,9 L1,9 L1,16 Z"
            fill="#7D7D7D"
          />
          <path
            d="M19,0 L2,0 C0.896,0 0,0.896 0,2 L0,9 L19,9 L19,0 Z M2,7 L17,7 L17,2 L2,2 L2,7 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'three-stacked-with-right-column-right':
      return (
        <g fillRule="evenodd">
          <path
            d="M19,0 L2,0 C0.896,0 0,0.896 0,2 L0,9 L19,9 L19,0 Z M18,1 L18,8 L1,8 L1,2 C1,1.448 1.448,1 2,1 L18,1 L18,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M19,16 L0,16 L0,23 C0,24.104 0.896,25 2,25 L19,25 L19,16 Z M18,17 L18,24 L2,24 C1.448,24 1,23.552 1,23 L1,17 L18,17 L18,17 Z"
            fill="#7D7D7D"
          />
          <path
            d="M0,17 L19,17 L19,8 L0,8 L0,17 Z M1,16 L18,16 L18,9 L1,9 L1,16 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L18,0 L18,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 L35,0 Z M20,23 L35,23 L35,2 L20,2 L20,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'three-stacked-with-right-column-left-middle':
      return (
        <g fillRule="evenodd">
          <path
            d="M35,0 L18,0 L18,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,23 C36,23.552 35.552,24 35,24 L19,24 L19,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M19,0 L2,0 C0.896,0 0,0.896 0,2 L0,9 L19,9 L19,0 Z M18,1 L18,8 L1,8 L1,2 C1,1.448 1.448,1 2,1 L18,1 L18,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M19,16 L0,16 L0,23 C0,24.104 0.896,25 2,25 L19,25 L19,16 Z M18,17 L18,24 L2,24 C1.448,24 1,23.552 1,23 L1,17 L18,17 L18,17 Z"
            fill="#7D7D7D"
          />
          <path
            d="M0,17 L19,17 L19,8 L0,8 L0,17 Z M2,15 L17,15 L17,10 L2,10 L2,15 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'three-stacked-with-right-column-left-bottom':
      return (
        <g fillRule="evenodd">
          <path
            d="M35,0 L18,0 L18,25 L35,25 C36.104,25 37,24.104 37,23 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,23 C36,23.552 35.552,24 35,24 L19,24 L19,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M19,0 L2,0 C0.896,0 0,0.896 0,2 L0,9 L19,9 L19,0 Z M18,1 L18,8 L1,8 L1,2 C1,1.448 1.448,1 2,1 L18,1 L18,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M0,17 L19,17 L19,8 L0,8 L0,17 Z M1,16 L18,16 L18,9 L1,9 L1,16 Z"
            fill="#7D7D7D"
          />
          <path
            d="M19,16 L0,16 L0,23 C0,24.104 0.896,25 2,25 L19,25 L19,16 Z M2,23 L17,23 L17,18 L2,18 L2,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'six-block-top-left':
      return (
        <g fillRule="evenodd">
          <path
            d="M13,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L13,25 L13,12 Z M12,13 L12,24 L2,24 C1.448,24 1,23.552 1,23 L1,13 L12,13 L12,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L24,0 L24,13 L37,13 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,12 L25,12 L25,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M37,12 L24,12 L24,25 L35,25 C36.104,25 37,24.104 37,23 L37,12 Z M36,13 L36,23 C36,23.552 35.552,24 35,24 L25,24 L25,13 L36,13 L36,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M12,13 L25,13 L25,0 L12,0 L12,13 Z M13,12 L24,12 L24,1 L13,1 L13,12 Z"
            fill="#7D7D7D"
          />
          <path
            d="M12,25 L25,25 L25,12 L12,12 L12,25 Z M13,24 L24,24 L24,13 L13,13 L13,24 Z"
            fill="#7D7D7D"
          />
          <path
            d="M13,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L13,13 L13,0 Z M2,11 L11,11 L11,2 L2,2 L2,11 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'six-block-top-middle':
      return (
        <g fillRule="evenodd">
          <path
            d="M13,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L13,13 L13,0 Z M12,1 L12,12 L1,12 L1,2 C1,1.448 1.448,1 2,1 L12,1 L12,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M13,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L13,25 L13,12 Z M12,13 L12,24 L2,24 C1.448,24 1,23.552 1,23 L1,13 L12,13 L12,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L24,0 L24,13 L37,13 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,12 L25,12 L25,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M37,12 L24,12 L24,25 L35,25 C36.104,25 37,24.104 37,23 L37,12 Z M36,13 L36,23 C36,23.552 35.552,24 35,24 L25,24 L25,13 L36,13 L36,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M12,25 L25,25 L25,12 L12,12 L12,25 Z M13,24 L24,24 L24,13 L13,13 L13,24 Z"
            fill="#7D7D7D"
          />
          <path
            d="M12,13 L25,13 L25,0 L12,0 L12,13 Z M14,11 L23,11 L23,2 L14,2 L14,11 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'six-block-top-right':
      return (
        <g fillRule="evenodd">
          <path
            d="M13,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L13,13 L13,0 Z M12,1 L12,12 L1,12 L1,2 C1,1.448 1.448,1 2,1 L12,1 L12,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M13,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L13,25 L13,12 Z M12,13 L12,24 L2,24 C1.448,24 1,23.552 1,23 L1,13 L12,13 L12,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M37,12 L24,12 L24,25 L35,25 C36.104,25 37,24.104 37,23 L37,12 Z M36,13 L36,23 C36,23.552 35.552,24 35,24 L25,24 L25,13 L36,13 L36,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M12,13 L25,13 L25,0 L12,0 L12,13 Z M13,12 L24,12 L24,1 L13,1 L13,12 Z"
            fill="#7D7D7D"
          />
          <path
            d="M12,25 L25,25 L25,12 L12,12 L12,25 Z M13,24 L24,24 L24,13 L13,13 L13,24 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L24,0 L24,13 L37,13 L37,2 C37,0.896 36.104,0 35,0 L35,0 Z M26,11 L35,11 L35,2 L26,2 L26,11 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'six-block-bottom-left':
      return (
        <g fillRule="evenodd">
          <path
            d="M13,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L13,13 L13,0 Z M12,1 L12,12 L1,12 L1,2 C1,1.448 1.448,1 2,1 L12,1 L12,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L24,0 L24,13 L37,13 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,12 L25,12 L25,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M37,12 L24,12 L24,25 L35,25 C36.104,25 37,24.104 37,23 L37,12 Z M36,13 L36,23 C36,23.552 35.552,24 35,24 L25,24 L25,13 L36,13 L36,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M12,13 L25,13 L25,0 L12,0 L12,13 Z M13,12 L24,12 L24,1 L13,1 L13,12 Z"
            fill="#7D7D7D"
          />
          <path
            d="M12,25 L25,25 L25,12 L12,12 L12,25 Z M13,24 L24,24 L24,13 L13,13 L13,24 Z"
            fill="#7D7D7D"
          />
          <path
            d="M13,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L13,25 L13,12 Z M2,23 L11,23 L11,14 L2,14 L2,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'six-block-bottom-middle':
      return (
        <g fillRule="evenodd">
          <path
            d="M13,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L13,13 L13,0 Z M12,1 L12,12 L1,12 L1,2 C1,1.448 1.448,1 2,1 L12,1 L12,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M13,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L13,25 L13,12 Z M12,13 L12,24 L2,24 C1.448,24 1,23.552 1,23 L1,13 L12,13 L12,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L24,0 L24,13 L37,13 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,12 L25,12 L25,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M37,12 L24,12 L24,25 L35,25 C36.104,25 37,24.104 37,23 L37,12 Z M36,13 L36,23 C36,23.552 35.552,24 35,24 L25,24 L25,13 L36,13 L36,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M12,13 L25,13 L25,0 L12,0 L12,13 Z M13,12 L24,12 L24,1 L13,1 L13,12 Z"
            fill="#7D7D7D"
          />
          <path
            d="M12,25 L25,25 L25,12 L12,12 L12,25 Z M14,23 L23,23 L23,14 L14,14 L14,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    case 'six-block-bottom-right':
      return (
        <g fillRule="evenodd">
          <path
            d="M13,0 L2,0 C0.896,0 0,0.896 0,2 L0,13 L13,13 L13,0 Z M12,1 L12,12 L1,12 L1,2 C1,1.448 1.448,1 2,1 L12,1 L12,1 Z"
            fill="#7D7D7D"
          />
          <path
            d="M13,12 L0,12 L0,23 C0,24.104 0.896,25 2,25 L13,25 L13,12 Z M12,13 L12,24 L2,24 C1.448,24 1,23.552 1,23 L1,13 L12,13 L12,13 Z"
            fill="#7D7D7D"
          />
          <path
            d="M35,0 L24,0 L24,13 L37,13 L37,2 C37,0.896 36.104,0 35,0 M35,1 C35.552,1 36,1.448 36,2 L36,12 L25,12 L25,1 L35,1"
            fill="#7D7D7D"
          />
          <path
            d="M12,13 L25,13 L25,0 L12,0 L12,13 Z M13,12 L24,12 L24,1 L13,1 L13,12 Z"
            fill="#7D7D7D"
          />
          <path
            d="M12,25 L25,25 L25,12 L12,12 L12,25 Z M13,24 L24,24 L24,13 L13,13 L13,24 Z"
            fill="#7D7D7D"
          />
          <path
            d="M37,12 L24,12 L24,25 L35,25 C36.104,25 37,24.104 37,23 L37,12 Z M26,23 L35,23 L35,14 L26,14 L26,23 Z"
            fill="#FFFFFF"
          />
        </g>
      );
    default:
      return <path />;
  }
};

const LayoutIcon = ({
  name = '',
  viewBox = '0 0 37 25',
  width = '37',
  height = '25',
  className = 'section-area__layout-icon',
  ...props
}) => {
  return (
    <svg
      aria-label={`${name}`}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={`${className} ${name}`}
      {...props}
    >
      {getPath(name)}
    </svg>
  );
};

LayoutIcon.propTypes = {
  name: string.isRequired,
};

export default LayoutIcon;
